import "./product.css";

const Product = ({ img, link, name, technology }) => {
  console.log(technology);
  return (
    <div className="p">
      <div className="p-browser">
        <div className="p-circle"></div>
        <div className="p-circle"></div>
        <div className="p-circle"></div>
      </div>
      <div className="project_detail" >
        <div className="pText">
          <h4 className="project-name">{name}</h4>
          <p><span className="techSpan">Technology used:</span> <br /> {technology}</p>
        </div>
<div className="p-imgDiv" >
<a href={link} target="_blank" rel="noreferrer">
          <img src={img} alt=""  className="p-img" />
        </a>
</div>
       

      </div>
      <a href={link} target="_blank" rel="noreferrer">
         <p className="siteLink">Go to wesite</p> 
        </a>

    </div>
  );
};

export default Product;
